<template>
  <div>
    <h3 class="dark-orange--text">Usuarios con solicitudes pendientes</h3>
    <br>
		<v-layout>
			<v-flex md4 class="px-4">
        <v-text-field v-model="filter.request_user" append-icon="search" label=" Trabajador..." hide-details/>
			</v-flex>

			<v-flex md4 class="px-4">
        <v-autocomplete
          deletable-chips
          small-chips
          v-model="selectedStates"
          :items="states"
          :search-input.sync="searchStates"
          hide-details
          multiple
          chips
          label="Vigencia"/>
			</v-flex>
      <v-flex xs12 md4 style="text-align: end;">
        <v-btn color="secondary"  @click="exportExcel" v-if="myPermissions.includes(17)" :style="dark_t?'color:black':''">
          <v-icon></v-icon>
          <span>Exportar Excel</span>
        </v-btn>
      </v-flex>
		</v-layout>

		<v-layout>
			<v-flex>
        <v-data-table
          :headers="headers"
          :items="filteredRows"
          item-key="id"
          class="tablaT1"
          :class="dark_t?'dark':''">
          <template v-slot:item="props">
            <tr>
              <td>
                <fs1-span>{{props.item.request_username}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.request_user}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.request_type}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.request_name}}</fs1-span>
              </td>
              <td>
                
                <span
                  :class="['safety-tag', statusColor[props.item.validity]]">
                  <fs1-span>{{props.item.validity}}</fs1-span>
                </span>
              </td>
              <td>
                <fs1-span>{{props.item.expiration_date}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.delay_days}}</fs1-span>
              </td>
            </tr>
          </template>
        </v-data-table>
			</v-flex>
		</v-layout>
	
	</div>
</template>

<script>
import { getExportAsiRequests  as exportExcel } from '@/requests/ac';
import { customFilter } from '@/functions/general.js';

export default {
  data() {
    return {
      selectedStates: ['N/A', 'Por vencer', 'Vencido'],
      states: [
        'N/A', 'Por vencer', 'Vencido'
      ],
      searchStates: '',
			filter: {
				request_user: '',
      },
      statusNames: ['N/A', 'Por vencer', 'Vencido'],
      statusColor: {undefined:'','Por vencer':'yellow','Vencido':'red'},
    };
  },
  computed: {
    userAssets() {return this.$store.getters.userAssets},
    rows() { return this.userAssets },
    filteredRows() {
      const rows = this.rows.filter(r => this.selectedStates.includes(r.validity));
			return rows.filter(r => customFilter(r, this.filter));
    },
    headers() {
      return [
				{ text: 'username',  value: 'request_username' },
				{ text: 'Solicitante',  value: 'request_user' },
				{ text: 'Tipo',  value: 'request_type' },
				{ text: 'Solicitud',  value: 'request_name' },
				{ text: 'Vigencia',  value: 'validity' },
				{ text: 'Vencimiento',  value: 'expiration_date' },
				{ text: 'Días de retraso',  value: 'delay_days' },
      ];
		},
  },
  methods:{
		async exportExcel(){
      this.setProgress({show:true,message:'Cargando...'});
      if(!await this.assignAccess()) return;
      const {selectedStates} = this;
			exportExcel(Object.assign({},this.filter,{validity:selectedStates}))
        .then(r => this.setProgress({show:false}))
        .catch(e => this.getError(e));
		},
  }
};
</script>
